import { useNavigate } from 'react-router-dom';
import styles from './ButtonLogout.module.css';
import { useAuth } from '../../../../hooks/useAuth';

export function ButtonLogout() {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  async function logOff() {
    signOut();
    sessionStorage.removeItem('cart');
    sessionStorage.removeItem('remainingPoints');
    navigate('/');
  }

  return (
    <div className="d-flex align-items-center">
      <button className={`${styles.backButton} me-3`} onClick={logOff}>
        <i className="material-icons-outlined">west</i>
      </button>

      <span className="fs-5">Cadastro de Dados</span>
    </div>
  );
}
